import React from "react";
import Link from "gatsby-link";
import Helmet from "react-helmet";

import {
  PageTop,
  TitleH1,
  Title,
  SidebarNews,
  InfoBlock,
  Main,
  Content,
  Row,
  Col2
} from "../layouts/layouts";
import SideBarRight from "../layouts/SideBarRight";
import Gallery from "../layouts/gallery";

import thumb1 from "../assets/pylehti-page-001-155x155-3092.jpg";
import thumb2 from "../assets/fysioterapiasta_psykoterapiaan-155x155-7489.jpg";
import img1 from "../assets/pylehti-page-001.jpg";
import img2 from "../assets/fysioterapiasta_psykoterapiaan.jpg";

class Psykoterapia extends React.Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Kirsti Louko - Psykoterapia</title>
        </Helmet>
        <PageTop>
          <TitleH1>PSYKOTERAPIA</TitleH1>
          <p>
            Psykoterapia on elämän kriisien hoitamista keskustelun avulla
            psykoterapeuttisessa yhteistyösuhteessa.
          </p>
          <p>
            Terapiaan hakeutumisen tavallisimmat syyt ovat ahdistus, masennus,
            pelot sekä ongelmat ihmissuhteissa, työssä tai opiskelussa.​​
          </p>
        </PageTop>
        <Content>
          <SideBarRight />
          <Main column>
            <Title>KELAN KUNTOUTUSPSYKOTERAPIA</Title>
            <p>
              Kuntoutuspsykoterapian tavoitteena on tukea ja parantaa
              kuntoutujan työ- ja opiskelukykyä. Kuntoutuksella turvataan
              työelämässä pysyminen tai sinne siirtyminen, työhön paluu tai
              opintojen edistyminen.
            </p>

            <p>
              Psykoterapian tarve perustuu yksilölliseen terapian tarpeen
              arvioon ja kuntoutussuunnitelmaan tai B-lääkärinlausuntoon, johon
              sisältyy psykiatrin arvio diagnoosista ja kuntoutustarpeesta.
              Kelan kuntoutuksena kustantamassa psykoterapiassa Kela maksaa osan
              psykoterapeutin palkkiosta. Psykoterapiaa tuetaan
              harkinnanvaraisena kuntoutuksena. Se myönnetään 16-67 vuotiaille.
            </p>
            <p>
              Lähde:{" "}
              <a href="http://www.kela.fi/kuntoutuspsykoterapia">
                KELA kuntoutuspsykoterapia
              </a>
            </p>
            <Row>
              <Col2>
                <Title small>KÄYTTÄMÄNI TERAPIASUUNTAUS:</Title>
                <p>
                  <a href="https://ratkes.fi/yhdistys/">
                    Ratkaisukeskeinen psykoterapia
                  </a>
                </p>
                {/* <p><strong>Ryhmät: Naiseus-koulu – ratkaisukeskeisen psykoterapian sovellus</strong></p>
                <p>Tavoitteena on naisten hyvinvoinnin kehittäminen naiseus-, kehollisuus- ja seksuaalisuus-teemojen kautta. */}
                &nbsp;<Link to="/yhteystiedot">Kysy lisää!</Link>
              </Col2>
              <Col2>
                <Gallery
                  images={[
                    { src: `${img1}`, thumb: `${thumb1}` },
                    { src: `${img2}`, thumb: `${thumb2}` }
                  ]}
                />
              </Col2>
            </Row>
          </Main>
        </Content>
      </div>
    );
  }
}

export default Psykoterapia;



// WEBPACK FOOTER //
// ./src/pages/psykoterapia.js